'use client';

import dynamic from 'next/dynamic';

export const SmartAssistant = dynamic(
  () =>
    import(/* webpackChunkName: 'SmartAssistant' */ './SmartAssistant.client').then(
      (mod) => mod.SmartAssistant,
    ),
  {
    ssr: false,
  },
);
